import ApiService from "../../Services/ApiService";

export default {
    state: {
        userSettings: [],
        userTagsSettings: {},
        userFilterByTagsSettings: false
    },
    getters: {
        getUserSettings(state) {
            return state.userSettings;
        },
        getUserTagsSettings(state) {
            return state.userTagsSettings;
        },
        getFilterByTagsSettings(state) {
            return state.userFilterByTagsSettings;
        }
    },
    mutations: {
        setUserSettings(state, payload) {
            state.userSettings = payload;
        },
        setUserTagsSettings(state, payload) {
            state.userTagsSettings = payload;
        },
        setFilterByTagsSettings(state, payload) {
            state.userFilterByTagsSettings = payload;
        },
        addUserSettings(state, item) {
            state.userSettings.push(item);
        },
        removeUserSettings(state, index) {
            state.userSettings.splice(index, 1);
        }
    },
    actions: {
        async loadNewsTagsSettings({ commit }, user_id) {
            const tags = JSON.parse((await ApiService.getNewsTagsSettings(user_id)).data.content).user_news_tags;

            commit("setUserTagsSettings", tags);
        },
        async loadFilterByTagsSettings({ commit }, user_id) {
            const checkIfExists = (await ApiService.getFilterByTagsSettings(user_id)).data;

            const flag = (checkIfExists !== "") ? JSON.parse((await ApiService.getFilterByTagsSettings(user_id)).data.content).user_filter_by_tags : false;

            commit("setFilterByTagsSettings", flag);
        },
        async updateNewsTagsSettings({ commit }, dataObject) {
            await ApiService.setNewsTagsSettings(dataObject);

            const tags = JSON.parse((await ApiService.getNewsTagsSettings(dataObject.user_id)).data.content).user_news_tags;

            commit("setUserTagsSettings", tags);
        },
        async updateFilterByTagsSettings({ commit }, dataObject) {
            await ApiService.setNewsTagsSettings(dataObject);

            const flag = JSON.parse((await ApiService.getFilterByTagsSettings(dataObject.user_id)).data.content).user_filter_by_tags;

            commit("setFilterByTagsSettings", flag);
        }
    },
};
